export default __webpack_public_path__ + "132404b54c3c0ffe61fe507c9e70c003.svg";